import { getUserLocation } from './userLocation'
import { getLocaleLanguage } from './localLanguage'
import { jumpTo, encodeParams, getParams, isJSON, RouterType } from './jumpToPage'
import Logan from './logan'
import Raptor from './raptor'

// 是否是沙特新货币符号
const isNewSaCurrency = (i18nClient: any) => i18nClient?.enableReplaceRiyalSymbol()

// 替换为沙特新货币符号
const getNewSaCurrency = (i18nClient: any, val: string) => i18nClient?.replaceRiyalSymbol(val || '') || val

export { Logan, Raptor, getUserLocation, getLocaleLanguage, jumpTo, encodeParams, getParams, isJSON, RouterType, isNewSaCurrency, getNewSaCurrency }
